// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assetData//icons/check_box_checked.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assetData/icons/date_picker.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-slider-sec .slick-dots {
  bottom: 0px;
  text-align: center;
  left: 0%;
}
.custom-slider-sec .slick-dots li button:before {
  font-size: 10px;
  color: #747474;
}
.custom-slider-sec .slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: #fff;
}
.custom-slider-sec .slick-dots li {
  width: 10px;
  height: 10px;
}
.Integrated-slider .slider-sec {
  padding: 0 10px;
}
.content-tab .tabs {
  padding: 24px;
  border-left: 4px solid #f9fafa;
  margin-bottom: 10px;
  cursor: pointer;
}
.image-tab .img_tab {
  display: none;
}
.image-tab .img_tab.active-img {
  display: block;
}
.content-tab .active-tab {
  border-left: 4px solid #f2673a;
}
.Integrated-slider .slick-next:before {
  border: 1px solid #3a3a3a;
  content: ">";
  font-size: 20px;
  opacity: 1;
  color: #3a3a3a;
  padding: 9px 16px;
  border-radius: 6px;
  font-family: monospace;
}
.Integrated-slider .slick-prev:before {
  content: "<";
  font-size: 20px;
  opacity: 1;
  color: #3a3a3a;
  padding: 9px 16px;
  border-radius: 6px;
  font-family: monospace;
  border: 1px solid #3a3a3a;
}
.Integrated-slider .slick-prev {
  left: -50px;
  z-index: 1;
}
.content-tab .tabs {
  display: block;
}
.about-team-wrappers .slick-next:before {
  border: 1px solid #ffffff;
  content: ">";
  font-size: 20px;
  opacity: 1;
  color: #ffffff;
  padding: 9px 16px;
  border-radius: 6px;
  font-family: monospace;
}
.about-team-wrappers .slick-prev:before {
  content: "<";
  font-size: 20px;
  opacity: 1;
  color: #ffffff;
  padding: 9px 16px;
  border-radius: 6px;
  font-family: monospace;
  border: 1px solid #ffffff;
}
.about-team-wrappers .slick-prev {
  left: -80px;
  z-index: 1;
  top: 32%;
}
.about-team-wrappers .slick-next {
  right: -50px;
  z-index: 1;
  top: 32%;
}
.border-content-tab {
  width: 100%;
  max-width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 35px 0 75px;
}
.border-content-tab .border-content {
  width: 100%;
  max-width: 25%;
}
.border-content-tab .border-content h4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  height: 80px;
  border-radius: 8px;
  background: #f2f4f5;
  margin: auto;
  color: #3a3a3a;
  font-size: 16px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  cursor: pointer;
}
.border-image-tab {
  width: 100%;
  max-width: 1375px;
  margin: auto;
}
.border-image-tab .border-image-wrps .border-image-cont {
  display: flex;
  align-items: center;
  gap: 90px;
}
.border-image-tab .border-image-wrps {
  display: none;
}
.border-image-tab .border-image-wrps.active-border-image {
  display: block;
}
.border-content-tab .border-content.border-active h4 {
  background: #25a86a;
  color: #ffffff;
}

/* service page css */

.multitasking-wrapper:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: -99%;
  display: block;
  height: auto;
  width: 100%;
  background: #231c42;
}
.multidroping-wrapper:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  display: block;
  height: auto;
  width: 100%;
  background: #231c42;
}
.multiaccount-wrapper:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: -99%;
  display: block;
  height: auto;
  width: 100%;
  background: #231c42;
}
.multidownld-wrapper:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -100%;
  display: block;
  height: auto;
  width: 100%;
  background: #231c42;
}

/* pricing page css */

span.cross-icon {
  position: absolute;
  right: 60px;
  top: 25px;
  font-size: 22px;
  font-weight: 400;
  cursor: pointer;
}
.popup-section-wrapper .popup-form {
  top: 8%;
  width: 40%;
  height: auto;
  background: #fff;
  position: absolute;
  right: 26%;
  padding: 70px 100px 12px;
  border-radius: 16px;
  z-index: 5;
  overflow: auto;
}
.popup-section-wrapper .popup-overlay {
  position: absolute;
  top: 0;
  background: rgb(219 208 208 / 30%);
  height: 100%;
  width: 100%;
  z-index: 5;
}
.popup-section-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 11;
}
input.PhoneInputInput {
  outline: 0;
}

.accordion-wrps-item {
  width: 100%;
  max-width: 850px;
  margin: auto;
  padding-top: 55px;
}
.accordion-wrps-item .accordion-quest {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.accordion-quest span.next-prev-icon svg.circle-minus {
  font-size: 25px;
}
.accordion-quest span.next-prev-icon svg.circle-plus {
  font-size: 20px;
  border-radius: 50%;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
}
.accordion-wrps-item .accordion-list-wrps {
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 20px;
  padding-top: 20px;
  cursor: pointer;
}
.accordion-list-wrps .accordion-answ p {
  transition: all 0.5s ease-out;
}
.accord-cont-wrps {
  display: none;
}
.accord-cont-wrps.active-cont-wrps {
  display: block;
}
.accord-cont.accord-active p {
  background: #25a86a;
  color: #ffffff;
  cursor: pointer;
}
.accord-cont p {
  cursor: pointer;
}

/* Login Page css */

.visible-icons button.visib-icns {
  cursor: pointer;
  float: right;
  position: relative;
  margin-top: -44px;
  margin-right: 15px;
}
.visible-icons button.visib-icns svg {
  color: #b2b2b2;
  font-size: 19px;
}
.password-visible-icons button.password-visib-icns {
  cursor: pointer;
  float: right;
  position: relative;
  margin-top: -45px;
  margin-right: 15px;
}
.password-visible-icons button.password-visib-icns svg {
  color: #b2b2b2;
  font-size: 19px;
}
.registr-visib-icns {
  cursor: pointer;
  float: right;
  position: relative;
  margin-top: -40px;
  margin-right: 15px;
}
.registr-visib-icns svg {
  color: #b2b2b2;
  font-size: 19px;
}
.register-number input.PhoneInputInput {
  background: #f7f7f7;
}
span.error {
  color: #a82525;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.register-number {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  background: #f7f7f7;
  padding: 12px 6px;
  gap: 6px;
  margin-top: 10px;
  margin-bottom: 5px;
  border: 1px solid #b6b6b6;
}
.contact-number {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px 6px;
  gap: 6px;
  margin-top: 12px;
  margin-bottom: 16px;
  border: 1px solid #b6b6b6;
}
.password-hover {
  position: relative;
}
.password-hover .hover-imgs {
  position: absolute;
  bottom: 7%;
  right: 40%;
  z-index: 5;
}
.password-hover-show {
  position: absolute;
  top: 0;
  right: -95px;
  opacity: 0;
  transition: 0.5s ease;
  z-index: 5;
  visibility: hidden;
}
.password-hover .password-aline:hover .password-hover-show {
  opacity: 1;
  visibility: visible;
}
.hover-imgs img {
  display: inline-block;
}
.error-btn ul {
  list-style: circle;
  padding-left: 20px;
}
.error-btn ul li {
  color: #a82525;
  font-size: 12px;
}
.error-btn ul li span.error {
  font-size: 12px;
  line-height: 16px;
}

.about-leader-wrappers {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 50px;
}
.about-team-slider p {
  min-height: 60px;
}
.term-uses-wrapper-item {
  margin-top: 30px;
}
.specik-field input {
  width: 100%;
  outline: 0;
  border-bottom: 1px solid #b8b8b8;
  background: #fff;
  color: #b7b7b7;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  padding-bottom: 5px;
  font-weight: 400;
  line-height: 140%;
}
.specik-field {
  width: 100%;
  margin-top: 5px;
}
span.error-for {
  color: #a82525;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
div#pincode-form input::-webkit-inner-spin-button,
div#pincode-form input::-webkit-outer-spin-button {
  display: none;
}
.protect-login-wrps {
  padding-top: 155px;
  padding-bottom: 70px;
}
.protect-login {
  width: 100%;
  max-width: 475px;
  margin: auto;
  padding: 50px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  border-radius: 8px;
}

/* custom */
.custom-checkbox {
  /* Add if not using autoprefixer */
  appearance: none;
  /* For iOS < 15 to remove gradient background */
  background-color: #fff;
  /* Not removed via appearance */
  /* margin-inline: auto; */
  font: inherit;
  color: currentColor;
  width: 15px;
  aspect-ratio: 1/1;
  border: 1px solid var(--pri-orange);
  border-radius: 0.15em;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
  position: relative;
}

.custom-checkbox::before {
  content: " ";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  inset: 0;
  border-radius: 5%;
  opacity: 0;
  transition: 120ms transform ease-in-out;
}

.custom-checkbox:checked::before {
  opacity: 1;
}

::-webkit-calendar-picker-indicator {
  /* color: rgb(235, 191, 19); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  /* background-image: url("./assetData/icons/delete_icon.svg"); */
}

.hide-calendar-picker::-webkit-calendar-picker-indicator {
  opacity: 0;
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
  padding: 1em;
  /* background-color: rgba(255, 0, 0, 0.37); */
}

.improve-date-picker {
  position: relative;
  text-align: center;
  background-color: transparent;
  width: 100%;
}

.improve-date-picker::-webkit-calendar-picker-indicator {
  opacity: 0;
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
}

.custom-file-uploader {
  color: transparent;
}

.custom-file-uploader::-webkit-file-upload-button {
  /* visibility: hidden; */
  opacity: 0;
  width: 100%;
  z-index: 10;
  position: relative;
}

.custom-doc-uploader {
  position: relative;
  padding-block: 0.3rem;
  width: 200%;
}

.custom-doc-uploader::-webkit-file-upload-button {
  opacity: 0;
  width: 50px;
}

.app-container {
  width: 100%;
  max-width: 1440px;
  margin-inline: auto;
  padding-inline: 1rem;
}

/* Remove the default arrow buttons for number input */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

@media (max-width: 767px) {
  .custom-slider-sec .slick-dots {
    bottom: 0%;
    left: 0%;
  }
  .Integrated-slider .slick-prev {
    left: -9px;
  }
  .Integrated-slider .slick-next {
    right: 5px;
  }
  .Integrated-slider .slick-next:before {
    font-size: 18px;
    padding: 5px 10px;
  }
  .Integrated-slider .slick-prev:before {
    font-size: 18px;
    padding: 5px 10px;
  }
  .about-team-wrappers .slick-prev {
    left: -13px;
  }
  .about-team-wrappers .slick-next {
    right: 0px;
  }
  .about-team-wrappers .slick-next:before {
    font-size: 18px;
    padding: 5px 10px;
  }
  .about-team-wrappers .slick-prev:before {
    font-size: 18px;
    padding: 5px 10px;
  }
  .border-content-tab {
    max-width: 100%;
    flex-wrap: nowrap;
    gap: 15px;
    padding: 35px 0 55px;
  }
  .border-content-tab .border-content {
    max-width: 15%;
  }
  .border-content-tab .border-content h4 {
    width: 48px;
    height: 48px;
  }
  .border-image-tab .border-image-wrps .border-image-cont {
    gap: 65px;
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }
  .multitasking-wrapper:after {
    content: none;
    right: 0;
  }
  .multidroping-wrapper:after {
    content: none;
    left: 0;
  }
  .multiaccount-wrapper:after {
    content: none;
    right: 0;
  }
  .multidownld-wrapper:after {
    content: none;
    left: 0;
  }
  .accordion-wrps-item {
    max-width: 100%;
  }
  .popup-section-wrapper .popup-form {
    width: 100%;
    right: 0%;
    padding: 30px 20px;
  }
  span.cross-icon {
    right: 45px;
    top: 15px;
  }
  .password-hover-show {
    top: -90px;
    right: -15px;
  }
  .password-hover .hover-imgs {
    right: 45%;
  }
  .about-leader-wrappers {
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 0px;
  }
  .about-leader-wrappers .about-team-slider {
    padding-bottom: 45px;
  }
  .image-wrapper-item {
    padding-top: 75px;
  }
}

.progress-container {
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
  transform: translateX(0);
  opacity: 1;
}

.progress-container.slide-out {
  transform: translateX(100%); /* Slide out to the right */
  opacity: 0; /* Fade out */
}

.progress-container.hidden {
  display: none; /* Hide the element completely */
}

@media (prefers-color-scheme: dark) {
  .app {
    background: #ffff;
    min-height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;EACV,QAAQ;AACV;AACA;EACE,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,OAAO;EACP,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kCAAkC;EAElC,gBAAgB;EAChB,+CAA+C;EAC/C,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,qBAAqB;EACrB,+BAA+B;;EAE/B,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yDAAiE;EACjE,2BAA2B;EAC3B,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,yDAA0D;EAC1D,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,SAAS;IACT,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,OAAO;EACT;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,aAAa;IACb,OAAO;EACT;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;qBAEmB;EACnB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,2BAA2B,EAAE,2BAA2B;EACxD,UAAU,EAAE,aAAa;AAC3B;;AAEA;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".custom-slider-sec .slick-dots {\n  bottom: 0px;\n  text-align: center;\n  left: 0%;\n}\n.custom-slider-sec .slick-dots li button:before {\n  font-size: 10px;\n  color: #747474;\n}\n.custom-slider-sec .slick-dots li.slick-active button:before {\n  opacity: 0.75;\n  color: #fff;\n}\n.custom-slider-sec .slick-dots li {\n  width: 10px;\n  height: 10px;\n}\n.Integrated-slider .slider-sec {\n  padding: 0 10px;\n}\n.content-tab .tabs {\n  padding: 24px;\n  border-left: 4px solid #f9fafa;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n.image-tab .img_tab {\n  display: none;\n}\n.image-tab .img_tab.active-img {\n  display: block;\n}\n.content-tab .active-tab {\n  border-left: 4px solid #f2673a;\n}\n.Integrated-slider .slick-next:before {\n  border: 1px solid #3a3a3a;\n  content: \">\";\n  font-size: 20px;\n  opacity: 1;\n  color: #3a3a3a;\n  padding: 9px 16px;\n  border-radius: 6px;\n  font-family: monospace;\n}\n.Integrated-slider .slick-prev:before {\n  content: \"<\";\n  font-size: 20px;\n  opacity: 1;\n  color: #3a3a3a;\n  padding: 9px 16px;\n  border-radius: 6px;\n  font-family: monospace;\n  border: 1px solid #3a3a3a;\n}\n.Integrated-slider .slick-prev {\n  left: -50px;\n  z-index: 1;\n}\n.content-tab .tabs {\n  display: block;\n}\n.about-team-wrappers .slick-next:before {\n  border: 1px solid #ffffff;\n  content: \">\";\n  font-size: 20px;\n  opacity: 1;\n  color: #ffffff;\n  padding: 9px 16px;\n  border-radius: 6px;\n  font-family: monospace;\n}\n.about-team-wrappers .slick-prev:before {\n  content: \"<\";\n  font-size: 20px;\n  opacity: 1;\n  color: #ffffff;\n  padding: 9px 16px;\n  border-radius: 6px;\n  font-family: monospace;\n  border: 1px solid #ffffff;\n}\n.about-team-wrappers .slick-prev {\n  left: -80px;\n  z-index: 1;\n  top: 32%;\n}\n.about-team-wrappers .slick-next {\n  right: -50px;\n  z-index: 1;\n  top: 32%;\n}\n.border-content-tab {\n  width: 100%;\n  max-width: 1280px;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 30px;\n  padding: 35px 0 75px;\n}\n.border-content-tab .border-content {\n  width: 100%;\n  max-width: 25%;\n}\n.border-content-tab .border-content h4 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 320px;\n  height: 80px;\n  border-radius: 8px;\n  background: #f2f4f5;\n  margin: auto;\n  color: #3a3a3a;\n  font-size: 16px;\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 140%;\n  cursor: pointer;\n}\n.border-image-tab {\n  width: 100%;\n  max-width: 1375px;\n  margin: auto;\n}\n.border-image-tab .border-image-wrps .border-image-cont {\n  display: flex;\n  align-items: center;\n  gap: 90px;\n}\n.border-image-tab .border-image-wrps {\n  display: none;\n}\n.border-image-tab .border-image-wrps.active-border-image {\n  display: block;\n}\n.border-content-tab .border-content.border-active h4 {\n  background: #25a86a;\n  color: #ffffff;\n}\n\n/* service page css */\n\n.multitasking-wrapper:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: -99%;\n  display: block;\n  height: auto;\n  width: 100%;\n  background: #231c42;\n}\n.multidroping-wrapper:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: -100%;\n  display: block;\n  height: auto;\n  width: 100%;\n  background: #231c42;\n}\n.multiaccount-wrapper:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: -99%;\n  display: block;\n  height: auto;\n  width: 100%;\n  background: #231c42;\n}\n.multidownld-wrapper:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: -100%;\n  display: block;\n  height: auto;\n  width: 100%;\n  background: #231c42;\n}\n\n/* pricing page css */\n\nspan.cross-icon {\n  position: absolute;\n  right: 60px;\n  top: 25px;\n  font-size: 22px;\n  font-weight: 400;\n  cursor: pointer;\n}\n.popup-section-wrapper .popup-form {\n  top: 8%;\n  width: 40%;\n  height: auto;\n  background: #fff;\n  position: absolute;\n  right: 26%;\n  padding: 70px 100px 12px;\n  border-radius: 16px;\n  z-index: 5;\n  overflow: auto;\n}\n.popup-section-wrapper .popup-overlay {\n  position: absolute;\n  top: 0;\n  background: rgb(219 208 208 / 30%);\n  height: 100%;\n  width: 100%;\n  z-index: 5;\n}\n.popup-section-wrapper {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 11;\n}\ninput.PhoneInputInput {\n  outline: 0;\n}\n\n.accordion-wrps-item {\n  width: 100%;\n  max-width: 850px;\n  margin: auto;\n  padding-top: 55px;\n}\n.accordion-wrps-item .accordion-quest {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.accordion-quest span.next-prev-icon svg.circle-minus {\n  font-size: 25px;\n}\n.accordion-quest span.next-prev-icon svg.circle-plus {\n  font-size: 20px;\n  border-radius: 50%;\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n}\n.accordion-wrps-item .accordion-list-wrps {\n  border-bottom: 1px solid #c4c4c4;\n  padding-bottom: 20px;\n  padding-top: 20px;\n  cursor: pointer;\n}\n.accordion-list-wrps .accordion-answ p {\n  transition: all 0.5s ease-out;\n}\n.accord-cont-wrps {\n  display: none;\n}\n.accord-cont-wrps.active-cont-wrps {\n  display: block;\n}\n.accord-cont.accord-active p {\n  background: #25a86a;\n  color: #ffffff;\n  cursor: pointer;\n}\n.accord-cont p {\n  cursor: pointer;\n}\n\n/* Login Page css */\n\n.visible-icons button.visib-icns {\n  cursor: pointer;\n  float: right;\n  position: relative;\n  margin-top: -44px;\n  margin-right: 15px;\n}\n.visible-icons button.visib-icns svg {\n  color: #b2b2b2;\n  font-size: 19px;\n}\n.password-visible-icons button.password-visib-icns {\n  cursor: pointer;\n  float: right;\n  position: relative;\n  margin-top: -45px;\n  margin-right: 15px;\n}\n.password-visible-icons button.password-visib-icns svg {\n  color: #b2b2b2;\n  font-size: 19px;\n}\n.registr-visib-icns {\n  cursor: pointer;\n  float: right;\n  position: relative;\n  margin-top: -40px;\n  margin-right: 15px;\n}\n.registr-visib-icns svg {\n  color: #b2b2b2;\n  font-size: 19px;\n}\n.register-number input.PhoneInputInput {\n  background: #f7f7f7;\n}\nspan.error {\n  color: #a82525;\n  font-family: Open Sans;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n.register-number {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: 8px;\n  background: #f7f7f7;\n  padding: 12px 6px;\n  gap: 6px;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  border: 1px solid #b6b6b6;\n}\n.contact-number {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: 8px;\n  background: #ffffff;\n  padding: 10px 6px;\n  gap: 6px;\n  margin-top: 12px;\n  margin-bottom: 16px;\n  border: 1px solid #b6b6b6;\n}\n.password-hover {\n  position: relative;\n}\n.password-hover .hover-imgs {\n  position: absolute;\n  bottom: 7%;\n  right: 40%;\n  z-index: 5;\n}\n.password-hover-show {\n  position: absolute;\n  top: 0;\n  right: -95px;\n  opacity: 0;\n  transition: 0.5s ease;\n  z-index: 5;\n  visibility: hidden;\n}\n.password-hover .password-aline:hover .password-hover-show {\n  opacity: 1;\n  visibility: visible;\n}\n.hover-imgs img {\n  display: inline-block;\n}\n.error-btn ul {\n  list-style: circle;\n  padding-left: 20px;\n}\n.error-btn ul li {\n  color: #a82525;\n  font-size: 12px;\n}\n.error-btn ul li span.error {\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.about-leader-wrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 590px;\n  margin: auto;\n  padding-top: 20px;\n  padding-bottom: 50px;\n}\n.about-team-slider p {\n  min-height: 60px;\n}\n.term-uses-wrapper-item {\n  margin-top: 30px;\n}\n.specik-field input {\n  width: 100%;\n  outline: 0;\n  border-bottom: 1px solid #b8b8b8;\n  background: #fff;\n  color: #b7b7b7;\n  font-family: Open Sans;\n  font-size: 14px;\n  font-style: normal;\n  padding-bottom: 5px;\n  font-weight: 400;\n  line-height: 140%;\n}\n.specik-field {\n  width: 100%;\n  margin-top: 5px;\n}\nspan.error-for {\n  color: #a82525;\n  font-family: Open Sans;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\ndiv#pincode-form input::-webkit-inner-spin-button,\ndiv#pincode-form input::-webkit-outer-spin-button {\n  display: none;\n}\n.protect-login-wrps {\n  padding-top: 155px;\n  padding-bottom: 70px;\n}\n.protect-login {\n  width: 100%;\n  max-width: 475px;\n  margin: auto;\n  padding: 50px;\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n  border-radius: 8px;\n}\n\n/* custom */\n.custom-checkbox {\n  /* Add if not using autoprefixer */\n  -webkit-appearance: none;\n  appearance: none;\n  /* For iOS < 15 to remove gradient background */\n  background-color: #fff;\n  /* Not removed via appearance */\n  /* margin-inline: auto; */\n  font: inherit;\n  color: currentColor;\n  width: 15px;\n  aspect-ratio: 1/1;\n  border: 1px solid var(--pri-orange);\n  border-radius: 0.15em;\n  transform: translateY(-0.075em);\n\n  display: grid;\n  place-content: center;\n  position: relative;\n}\n\n.custom-checkbox::before {\n  content: \" \";\n  position: absolute;\n  background-image: url(\"./assetData//icons/check_box_checked.svg\");\n  background-position: center;\n  inset: 0;\n  border-radius: 5%;\n  opacity: 0;\n  transition: 120ms transform ease-in-out;\n}\n\n.custom-checkbox:checked::before {\n  opacity: 1;\n}\n\n::-webkit-calendar-picker-indicator {\n  /* color: rgb(235, 191, 19); */\n  background-image: url(\"./assetData/icons/date_picker.svg\");\n  /* background-image: url(\"./assetData/icons/delete_icon.svg\"); */\n}\n\n.hide-calendar-picker::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  inset: 0;\n  width: 100%;\n  padding: 1em;\n  /* background-color: rgba(255, 0, 0, 0.37); */\n}\n\n.improve-date-picker {\n  position: relative;\n  text-align: center;\n  background-color: transparent;\n  width: 100%;\n}\n\n.improve-date-picker::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  inset: 0;\n  width: 100%;\n}\n\n.custom-file-uploader {\n  color: transparent;\n}\n\n.custom-file-uploader::-webkit-file-upload-button {\n  /* visibility: hidden; */\n  opacity: 0;\n  width: 100%;\n  z-index: 10;\n  position: relative;\n}\n\n.custom-doc-uploader {\n  position: relative;\n  padding-block: 0.3rem;\n  width: 200%;\n}\n\n.custom-doc-uploader::-webkit-file-upload-button {\n  opacity: 0;\n  width: 50px;\n}\n\n.app-container {\n  width: 100%;\n  max-width: 1440px;\n  margin-inline: auto;\n  padding-inline: 1rem;\n}\n\n/* Remove the default arrow buttons for number input */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n@media (max-width: 767px) {\n  .custom-slider-sec .slick-dots {\n    bottom: 0%;\n    left: 0%;\n  }\n  .Integrated-slider .slick-prev {\n    left: -9px;\n  }\n  .Integrated-slider .slick-next {\n    right: 5px;\n  }\n  .Integrated-slider .slick-next:before {\n    font-size: 18px;\n    padding: 5px 10px;\n  }\n  .Integrated-slider .slick-prev:before {\n    font-size: 18px;\n    padding: 5px 10px;\n  }\n  .about-team-wrappers .slick-prev {\n    left: -13px;\n  }\n  .about-team-wrappers .slick-next {\n    right: 0px;\n  }\n  .about-team-wrappers .slick-next:before {\n    font-size: 18px;\n    padding: 5px 10px;\n  }\n  .about-team-wrappers .slick-prev:before {\n    font-size: 18px;\n    padding: 5px 10px;\n  }\n  .border-content-tab {\n    max-width: 100%;\n    flex-wrap: nowrap;\n    gap: 15px;\n    padding: 35px 0 55px;\n  }\n  .border-content-tab .border-content {\n    max-width: 15%;\n  }\n  .border-content-tab .border-content h4 {\n    width: 48px;\n    height: 48px;\n  }\n  .border-image-tab .border-image-wrps .border-image-cont {\n    gap: 65px;\n    flex-wrap: wrap;\n    flex-direction: column-reverse;\n  }\n  .multitasking-wrapper:after {\n    content: none;\n    right: 0;\n  }\n  .multidroping-wrapper:after {\n    content: none;\n    left: 0;\n  }\n  .multiaccount-wrapper:after {\n    content: none;\n    right: 0;\n  }\n  .multidownld-wrapper:after {\n    content: none;\n    left: 0;\n  }\n  .accordion-wrps-item {\n    max-width: 100%;\n  }\n  .popup-section-wrapper .popup-form {\n    width: 100%;\n    right: 0%;\n    padding: 30px 20px;\n  }\n  span.cross-icon {\n    right: 45px;\n    top: 15px;\n  }\n  .password-hover-show {\n    top: -90px;\n    right: -15px;\n  }\n  .password-hover .hover-imgs {\n    right: 45%;\n  }\n  .about-leader-wrappers {\n    flex-wrap: wrap;\n    width: 100%;\n    padding-bottom: 0px;\n  }\n  .about-leader-wrappers .about-team-slider {\n    padding-bottom: 45px;\n  }\n  .image-wrapper-item {\n    padding-top: 75px;\n  }\n}\n\n.progress-container {\n  transition:\n    transform 0.5s ease,\n    opacity 0.5s ease;\n  transform: translateX(0);\n  opacity: 1;\n}\n\n.progress-container.slide-out {\n  transform: translateX(100%); /* Slide out to the right */\n  opacity: 0; /* Fade out */\n}\n\n.progress-container.hidden {\n  display: none; /* Hide the element completely */\n}\n\n@media (prefers-color-scheme: dark) {\n  .app {\n    background: #ffff;\n    min-height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
